<!-- @format -->

<template>
	<disabled-text v-if="disabled && showDisabledText" :value="label" :show-tag="showTag" />
	<template v-else>
		<van-field
			v-bind="$attrs"
			:model-value="label"
			is-link
			readonly
			:disabled="disabled"
			style="padding: 0"
			@click="
				() => {
					if (!disabled) {
						showPicker = true;
					}
				}
			"
		/>
		<van-popup v-model:show="showPicker" round position="bottom" teleport="body">
			<van-picker
				:columns="params"
				:columns-field-names="{ text: 'label', value: 'value' }"
				@cancel="showPicker = false"
				@confirm="onConfirm"
			/>
		</van-popup>
	</template>
</template>

<script setup lang="ts">
	import DisabledText from './disabledText.vue';
	import { useDictList, getDictTypes } from '@/api';
	import { getCache, setCache } from '@/utils/util';

	interface Props {
		modelValue: string;
		params?: { label: string; value: string; [key: string]: any }[];
		disabled?: boolean;
		showDisabledText?: boolean;
		citeType?: string;
		isDict?: boolean;
		multiple?: boolean;
		showTag?: boolean;
	}

	const showPicker = ref(false);

	const props = withDefaults(defineProps<Props>(), {
		modelValue: '',
		showDisabledText: true,
		isDict: false,
		showTag: true,
	});

	const onConfirm = ({ selectedOptions }) => {
		showPicker.value = false;
		value.value = selectedOptions[0].value;
	};

	const emit = defineEmits(['update:modelValue']);

	const value = computed({
		get() {
			return props.modelValue;
		},
		set(value) {
			emit('update:modelValue', value);
		},
	});

	const data = ref<{ label: string; value: string }[]>([]);

	const params = computed(() => (props.isDict || props.citeType ? data.value : props.params) || []);

	const label = computed(() => params.value.find((itm) => itm.value === value.value)?.label);

	const getDictList = async () => {
		if (props.isDict) {
			const res = await getDictTypes('factory');
			data.value = res;
		} else if (props.citeType) {
			const cacheRes = getCache('dictCache', props.citeType);
			if (cacheRes) {
				data.value = cacheRes;
			} else {
				const res = await useDictList({ dictType: props.citeType });
				setCache('dictCache', props.citeType, res);
				data.value = res;
			}
		}
	};

	getDictList();
</script>

<style scoped>
	.select {
		width: 100%;
	}

	.show-value {
		display: flex;
		gap: 3px;
		flex-wrap: wrap;
	}
</style>
